import React from "react";
import { Button } from "reactstrap";

export default function IncomeYoutubeEmptyState({ onSync, onViewUrls }) {
  return (
    <div className="inc-youtube-empty">
      <div className="inc-youtube-empty__icon" aria-hidden="true">
        <i className="fa fa-youtube-play" />
      </div>
      <h3 className="inc-youtube-empty__title">No YouTube revenue synced yet</h3>
      <p className="inc-youtube-empty__text">
        YouTube income is pulled from connected channels via ArtistSync. Link an artist&apos;s
        channel, then run a sync for the month you need. Revenue rows will appear here with
        video-level detail.
      </p>
      <ol className="inc-youtube-empty__steps">
        <li>Connect the artist&apos;s YouTube channel (Artists page)</li>
        <li>Run <strong>Sync YouTube</strong> for the target month</li>
        <li>Open a row to review videos, tax, and invoices</li>
      </ol>
      <div className="inc-youtube-empty__actions">
        <Button color="primary" onClick={onSync}>
          <i className="fa fa-refresh me-1" />
          Sync YouTube
        </Button>
        <Button color="secondary" outline onClick={onViewUrls}>
          <i className="fa fa-link me-1" />
          Revenue URLs
        </Button>
      </div>
    </div>
  );
}
